import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GithubAuthProvider, signInWithPopup } from "firebase/auth";
import toast from "react-hot-toast";
import { auth } from "../lib/firebase";

// This Firebase project already has GitHub sign-in enabled (shared with
// other, unrelated apps) and Juan already has an account on it — reuse that
// provider instead of asking him to create a separate email/password login.
// Firestore/Storage rules are the real gate: they only allow writes from his
// specific admin email, regardless of who else signs in with GitHub here.
const AdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    setLoading(true);
    try {
      await signInWithPopup(auth, new GithubAuthProvider());
      navigate("/admin/articles/new");
    } catch (err) {
      toast.error("Sign-in failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-space px-6">
      <div className="w-full max-w-sm rounded-3xl border border-white/10 bg-white/[0.03] p-8 text-center backdrop-blur-sm">
        <h1 className="text-2xl font-bold text-white">
          Nodefleet <span className="text-brand-gradient italic">Admin</span>
        </h1>
        <p className="mt-2 text-sm text-gray-400">
          Sign in with GitHub to publish articles.
        </p>

        <button
          type="button"
          onClick={handleSignIn}
          disabled={loading}
          className="mt-8 w-full rounded-full bg-primary px-7 py-3 font-semibold text-space-deep shadow-glow transition-colors hover:bg-primary-400 disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Sign in with GitHub"}
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
